// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./Browser__Tabs.bs.js");

var _map = {"normal":"normal","popup":"popup","panel":"panel","app":"app","devtools":"devtools"};

function windowTypeToJs(param) {
  return param;
}

function windowTypeFromJs(param) {
  return _map[param];
}

var _map$1 = {"normal":"normal","minimized":"minimized","maximized":"maximized","fullscreen":"fullscreen"};

function windowStateToJs(param) {
  return param;
}

function windowStateFromJs(param) {
  return _map$1[param];
}

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

function make(id, focused, top, left, width, height, tabs, incognito, type_, state, alwaysOnTop, sessionId, param) {
  var type_$1 = OptionUtils$SmartcutsMacros.$neg$question$great(type_, windowTypeToJs);
  var state$1 = OptionUtils$SmartcutsMacros.$neg$question$great(state, windowStateToJs);
  var tmp = {
    focused: focused,
    top: top,
    incognito: incognito,
    alwaysOnTop: alwaysOnTop
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (tabs !== undefined) {
    tmp.tabs = Caml_option.valFromOption(tabs);
  }
  if (type_$1 !== undefined) {
    tmp.type = Caml_option.valFromOption(type_$1);
  }
  if (state$1 !== undefined) {
    tmp.state = Caml_option.valFromOption(state$1);
  }
  if (sessionId !== undefined) {
    tmp.sessionId = Caml_option.valFromOption(sessionId);
  }
  return tmp;
}

function extractTabIds($$window) {
  var jsTabs = $$window.tabs;
  if (jsTabs !== undefined) {
    return Belt_List.keepMap($$Array.to_list($$Array.map(Browser__Tabs$SmartcutsMacros.Tab.fromJs, jsTabs)), (function (tab) {
                  return tab.id;
                }));
  } else {
    return /* [] */0;
  }
}

var Window_t_encode = include.t_encode;

var Window_t_decode = include.t_decode;

var $$Window = {
  t_encode: Window_t_encode,
  t_decode: Window_t_decode,
  make: make,
  extractTabIds: extractTabIds
};

var OnCreated = {};

var OnRemoved = {};

var OnFocusedChanged = {};

function make$1(populate, windowTypes, param) {
  var windowTypes$1 = OptionUtils$SmartcutsMacros.$neg$question$great(windowTypes, (function (param) {
          return $$Array.map(windowTypeToJs, param);
        }));
  var tmp = {};
  if (populate !== undefined) {
    tmp.populate = Caml_option.valFromOption(populate);
  }
  if (windowTypes$1 !== undefined) {
    tmp.windowTypes = Caml_option.valFromOption(windowTypes$1);
  }
  return tmp;
}

var GetInfo = {
  make: make$1
};

var CreateDataWithOptionalUrl = {};

var CreateDataWithMultipleUrls = {};

var CreateExternal = {
  CreateDataWithOptionalUrl: CreateDataWithOptionalUrl,
  CreateDataWithMultipleUrls: CreateDataWithMultipleUrls
};

var _map$2 = {"normal":"normal","popup":"popup","panel":"panel"};

function createTypeToJs(param) {
  return param;
}

function createTypeFromJs(param) {
  return _map$2[param];
}

function createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
  var tmp = {};
  if (tabId !== undefined) {
    tmp.tabId = Caml_option.valFromOption(tabId);
  }
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  if (top !== undefined) {
    tmp.top = Caml_option.valFromOption(top);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (focused !== undefined) {
    tmp.focused = Caml_option.valFromOption(focused);
  }
  if (incognito !== undefined) {
    tmp.incognito = Caml_option.valFromOption(incognito);
  }
  var tmp$1 = type_ !== undefined ? type_ : undefined;
  if (tmp$1 !== undefined) {
    tmp.type = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = state !== undefined ? state : undefined;
  if (tmp$2 !== undefined) {
    tmp.state = Caml_option.valFromOption(tmp$2);
  }
  if (setSelfAsOpener !== undefined) {
    tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
  }
  return browser.windows.create(tmp);
}

function createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
  var tmp = {
    url: url
  };
  if (tabId !== undefined) {
    tmp.tabId = Caml_option.valFromOption(tabId);
  }
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  if (top !== undefined) {
    tmp.top = Caml_option.valFromOption(top);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (focused !== undefined) {
    tmp.focused = Caml_option.valFromOption(focused);
  }
  if (incognito !== undefined) {
    tmp.incognito = Caml_option.valFromOption(incognito);
  }
  var tmp$1 = type_ !== undefined ? type_ : undefined;
  if (tmp$1 !== undefined) {
    tmp.type = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = state !== undefined ? state : undefined;
  if (tmp$2 !== undefined) {
    tmp.state = Caml_option.valFromOption(tmp$2);
  }
  if (setSelfAsOpener !== undefined) {
    tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
  }
  return browser.windows.create(tmp);
}

function createWithMultipleUrls(urls, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
  var tmp = {
    url: urls
  };
  if (tabId !== undefined) {
    tmp.tabId = Caml_option.valFromOption(tabId);
  }
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  if (top !== undefined) {
    tmp.top = Caml_option.valFromOption(top);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (focused !== undefined) {
    tmp.focused = Caml_option.valFromOption(focused);
  }
  if (incognito !== undefined) {
    tmp.incognito = Caml_option.valFromOption(incognito);
  }
  var tmp$1 = type_ !== undefined ? type_ : undefined;
  if (tmp$1 !== undefined) {
    tmp.type = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = state !== undefined ? state : undefined;
  if (tmp$2 !== undefined) {
    tmp.state = Caml_option.valFromOption(tmp$2);
  }
  if (setSelfAsOpener !== undefined) {
    tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
  }
  return browser.windows.create(tmp);
}

var UpdateExternal = {};

function update(windowId, left, top, width, height, focused, drawAttention, state, param) {
  var tmp = {};
  if (left !== undefined) {
    tmp.left = Caml_option.valFromOption(left);
  }
  if (top !== undefined) {
    tmp.top = Caml_option.valFromOption(top);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (focused !== undefined) {
    tmp.focused = Caml_option.valFromOption(focused);
  }
  if (drawAttention !== undefined) {
    tmp.drawAttention = Caml_option.valFromOption(drawAttention);
  }
  var tmp$1 = state !== undefined ? state : undefined;
  if (tmp$1 !== undefined) {
    tmp.state = Caml_option.valFromOption(tmp$1);
  }
  return browser.windows.update(windowId, tmp);
}

function getOnlyTabOfWindow($$window) {
  var arg = $$window.id;
  var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
  var windowId = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expect window.id");
  return Browser__Tabs$SmartcutsMacros.query({
                active: true,
                windowId: windowId
              }).then(function (tabs) {
              var len = tabs.length;
              if (len !== 1) {
                if (len !== 0) {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: created window has more than 1 tab; should have exactly 1");
                } else {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: created window has no tabs");
                }
              }
              var jsTab = tabs[0];
              return Promise.resolve(Browser__Tabs$SmartcutsMacros.Tab.fromJs(jsTab));
            });
}

var Helpers = {
  getOnlyTabOfWindow: getOnlyTabOfWindow
};

exports.windowTypeToJs = windowTypeToJs;
exports.windowTypeFromJs = windowTypeFromJs;
exports.windowStateToJs = windowStateToJs;
exports.windowStateFromJs = windowStateFromJs;
exports.$$Window = $$Window;
exports.OnCreated = OnCreated;
exports.OnRemoved = OnRemoved;
exports.OnFocusedChanged = OnFocusedChanged;
exports.GetInfo = GetInfo;
exports.CreateExternal = CreateExternal;
exports.createTypeToJs = createTypeToJs;
exports.createTypeFromJs = createTypeFromJs;
exports.createWithNoUrl = createWithNoUrl;
exports.createWithUrl = createWithUrl;
exports.createWithMultipleUrls = createWithMultipleUrls;
exports.UpdateExternal = UpdateExternal;
exports.update = update;
exports.Helpers = Helpers;
/* include Not a pure module */
